import { useState } from 'react'
import { addApp } from '../utils/network'
import { cgiCallWrapper } from 'utils/cgiCallWrapper'
import showAlert from 'utils/showAlert'

const useBindApp = props => {
    const { onClose, updateList } = props
    const [appid, setAppId] = useState('')
    const [error, setError] = useState('')
    const [disableSubmit, setDisableSubmit] = useState(false)

    const addAppHandler = (rowData, e) => {
        e.preventDefault()
    }

    const validateForm = () => {
        let errorMsg = ''
        if (!appid) {
            errorMsg = '请填写APPID'
        }
        setError(errorMsg)
        if (errorMsg) return false
        return true
    }

    const handleSubmit = async () => {
        try {
            if (!validateForm()) return
            setDisableSubmit(true)
            const res = await cgiCallWrapper(addApp, {
                appid,
            })
            setDisableSubmit(false)
            if (res.c !== 200) return
            showAlert('success', '添加APP成功')
            onClose()
            updateList() // 更新列表数据
        } catch (e) {
            showAlert('error', '程序错误，请联系客服')
            setDisableSubmit(false)
        }
    }
    return { addAppHandler, handleSubmit, disableSubmit, setDisableSubmit, appid, setAppId, error }
}

export default useBindApp
